'use client';

import { cn } from '@/lib/utils';

export type BrandMarkProps = {
  className?: string;
  /** Логический размер квадрата в px */
  size?: number;
};

/**
 * Знак бренда (зелёный шестиугольник) из `/brand/mark.svg`.
 */
export function BrandMark({ className, size = 32 }: BrandMarkProps) {
  return (
    <img
      src="/brand/mark.svg"
      width={size}
      height={size}
      alt=""
      className={cn('shrink-0 object-contain', className)}
      decoding="async"
      aria-hidden
    />
  );
}
